export default __webpack_public_path__ + "static/mariana-1d9db8170040906f7b737103fe45a59d.png";